import { Component } from '@angular/core';

@Component({
  selector: 'app-splash-page',
  imports: [],
  templateUrl: './splash-page.html',
  styleUrl: './splash-page.scss',
})
export class SplashPage {

}
